// Central content + image map for Fussboden Blum.
// All images are high-quality stock placeholders, easily swappable later
// with the real Blum photography.

export const LOGO = "https://customer-assets.emergentagent.com/job_1acf9827-6b0b-445f-a954-60cab3150dad/artifacts/hhz5n1ok_Logo.png";
export const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_1acf9827-6b0b-445f-a954-60cab3150dad/artifacts/18g7e0ho_logo_weiss_invertiert.png";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1598718544285-7180f670198b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  heroSecondary: "https://images.unsplash.com/photo-1546940084-6333670a0666?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  craftsman: "https://images.unsplash.com/photo-1646119955125-7ef8819c813a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showroom: "https://images.unsplash.com/photo-1643903032976-8c0d0556a8ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  measuring: "https://images.pexels.com/photos/1388944/floor-flooring-hand-man-1388944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  parkett: "https://images.unsplash.com/photo-1548268364-3acee266b695?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  livingWarm: "https://images.unsplash.com/photo-1769736438943-3c57cbd02c22?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  livingBright: "https://images.unsplash.com/photo-1597665863042-47e00964d899?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  cork: "https://images.unsplash.com/photo-1558051815-0f18e64e6280?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  laminat: "https://images.pexels.com/photos/5812/kitchen-boards-laminated-tabac.jpg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  drilling: "https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  refBright: "https://images.unsplash.com/photo-1599243272864-e9dd455966bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  team1: "https://images.unsplash.com/photo-1661447133325-a4a73386b9e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  team2: "https://images.unsplash.com/photo-1631396328075-9c65a7406f09?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  team3: "https://images.unsplash.com/photo-1631396327810-0299385c06bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  teamGroup: "https://images.pexels.com/photos/14653155/pexels-photo-14653155.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  // --- Echte Blum-Fotos ---
  family: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/s6fbsrrb_Blum-160619_015-KL-1024x684.jpg",
  staff: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/pfgawa1l_fussboden-blum_2019-4522-gruppenbild_web__2000x942.jpg",
  tuev: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/he6ewi3m_tuev-zertifikat.png",
  leistungenHeader: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/4brhvoe9_dienstleistungen_header__2000x773.jpg",
  produkteHeader: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/jdgr16fy_produkte_header__2000x773.jpg",
  karriereHero: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/xvcolovd_0181_Fu%C3%9Fboden%20Blum%20komprimiert%20Azubis%202.webp",
  jubilaeumHero: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/5zypu5je_50jahre_head__2038x788.webp",
  finderDesign: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/0n83fnzy_fussboden-blum_designbelaege-pvc.jpg",
  finderLaminat: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/gxrkr6si_blum-laminat-produkte.jpg",
  finderAkustik: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/l4yuq73r_fussboden-blum_raumakustikloesungen.jpg",
  ausstellungHeader: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/fhz3ldtj_ausstellung_header__1920x742.jpg",
  leistungPlanung: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/0hib2in4_fussboden-blum-planung.jpg",
  leistungVerlegung: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/beyt5obm_fussboden-blum-verlegung.jpg",
  leistungReinigung: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/ofh5al6s_fussboden-blum-reinigung.jpg",
  leistungMaterial: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/zl5d4qhb_fussboden-blum-material-lieferung.jpg",
  leistungAkustik: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/7qc3r7pb_fussboden-blum-raumakustik.jpg",
  firmengebaeude: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/so7nz4uk_Firmengeb%C3%A4ude-Fussboden-Blum.webp",
  kontaktBeratung: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/s05a7bl1_Kontakt-Beratung-Fussboden-Blum.webp",
  bodenZukunft: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/n2vcms4w_Boden-Zukunft-Award-Fussboden-Blum.png",
  praemiertHero: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/f7fcgvrn_blum_praemiert_schmal__2200x947.webp",
  awardTrophy: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/zfhawfz3_108934-02.jpg",
  awardVerleihung: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/j7880x18_108934-04.jpg",
  ncheckUrkunde: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/npttcto5_Teilnahmeurkunde-NCheck-360-mit-Copyright-Blum.webp",
  finderParkett: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/xree9s5j_pakett_und_dielen__1200x797.jpg",
  finderKork: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/jp0tf0tk_kork_0102__1200x797.jpg",
  finderTeppich: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/2f5tinh2_teppichboden__1200x797.jpg",
  sustainSeal: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/e7ayybxt_nachhaltigkeit-im-handwerk.jpg",
  slide1: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/i4zdxnz9_Slider-Bild-1.jpg",
  slide2: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/2jaw5k7x_Slider-Bild-2.jpg",
  slide3: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/rk9s9m9l_Slider-Bild-3.jpg",
  slide4: "https://customer-assets.emergentagent.com/job_fussboden-modern/artifacts/f9r3r4xi_Slider-Bild-4.jpg",
  teamNormal: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/tboez5qi_0021_Fu%C3%9Fboden%20Blum%20komprimiert%20Teambild%20normal.webp",
  teamJubel: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/dffo5x00_0070_Fu%C3%9Fboden%20Blum%20komprimiert%20Teambild%20Jubel.webp",
  gfMichael1: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/cfg2zuda_Michael-Blum-1.webp",
  gfMichael2: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/eeburnh4_Michael-Blum-2.webp",
  gfKonstantin1: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/nls5bbei_Konstantin-Blum-1.webp",
  gfKonstantin2: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/ct99pum1_Konstantin-Blum-2.webp",
  refHero: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/z020aunm_referenzen_header__2000x773.jpg",
  aboutTeam: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/xns7c45z_0361_Fu%C3%9Fboden%20Blum.webp",
};

export const NEWS = [
  {
    category: "Nachhaltigkeit",
    date: "19. August 2025",
    title: "Nachhaltigkeit mit Weitblick",
    teaser: "Die Fußboden Blum GmbH absolviert erfolgreich die NCheck-360-Zertifizierung – ein klares Bekenntnis zu verantwortungsvollem Handwerk.",
    img: IMG.cork,
    url: "https://www.fussboden-blum.de/nachhaltigkeit",
  },
  {
    category: "Auszeichnung",
    date: "23. Februar 2024",
    title: "Verleihung des Boden Zukunft Award 2024",
    teaser: "Zum ersten Mal lobten die drei Fachzeitschriften BTH Heimtex, FussbodenTechnik und Parkett Magazin den neuen Branchenpreis aus.",
    img: IMG.heroSecondary,
    url: "https://www.fussboden-blum.de/news/verleihung-des-bodenzukunft-award-2024",
  },
  {
    category: "Aktuelles",
    date: "17. Dezember 2021",
    title: "Betriebsurlaub zum Jahreswechsel",
    teaser: "Ein aufregendes und turbulentes Jahr neigt sich dem Ende zu. Wir informieren über unsere Öffnungszeiten rund um die Feiertage.",
    img: IMG.showroom,
    url: "https://www.fussboden-blum.de/news/85-betriebsurlaub-feiertage",
  },
];

export const HERO_SLIDES = [IMG.slide4, IMG.hero, IMG.slide1, IMG.slide2, IMG.slide3];

export const CONTACT = {
  phone: "06655 916190",
  phoneHref: "tel:+496655916190",
  email: "info@fussboden-blum.de",
  street: "Gewerbestraße 15",
  city: "36148 Kalbach",
  hours: [
    { d: "Montag – Freitag", t: "08:00 – 17:00 Uhr" },
    { d: "", t: "Samstags oder zu anderen Zeiten nur nach Vereinbarung." },
  ],
  social: [
    { name: "Instagram", handle: "@fussbodenblum", icon: "Instagram", url: "https://www.instagram.com/fussbodenblum/" },
    { name: "Facebook", handle: "Fussboden Blum", icon: "Facebook", url: "https://www.facebook.com/fussboden.blum/" },
  ],
};

export const SERVICES = [
  {
    icon: "MessagesSquare",
    title: "Beratung",
    text: "Persönlich, ehrlich und auf Augenhöhe – wir hören zu, bevor wir empfehlen. In unserer Ausstellung oder bei Ihnen vor Ort.",
  },
  {
    icon: "Truck",
    title: "Lieferung",
    text: "Materialien namhafter Hersteller – termingerecht, sorgfältig kalkuliert und zuverlässig auf die Baustelle gebracht.",
  },
  {
    icon: "Hammer",
    title: "Verlegung",
    text: "Vom Untergrund bis zur letzten Diele: handwerkliche Präzision durch unser Meisterteam – sauber, langlebig, exakt.",
  },
  {
    icon: "Sparkles",
    title: "Aufarbeitung",
    text: "Geschliffen, geölt, neu versiegelt – wir geben gealterten Holzböden und Bodenbelägen ihren Charakter zurück, statt sie zu ersetzen.",
  },
  {
    icon: "ShieldCheck",
    title: "Pflege",
    text: "Die richtige Pflege erhält Werte. Wir zeigen Ihnen, wie Ihr Boden über Jahrzehnte schön bleibt.",
  },
  {
    icon: "AudioLines",
    title: "Raumakustik",
    text: "TÜV-zertifizierte Akustiklösungen für Büro, Homeoffice und Wohnräume – damit Räume nicht nur gut aussehen, sondern sich gut anfühlen.",
  },
];

export const FINDER = [
  {
    name: "Parkett & Dielen",
    tag: "ZEITLOS, MODERN & WERTBESTÄNDIG",
    desc: "Echtes Holz für Generationen. Warm, natürlich und mehrfach renovierbar.",
    img: IMG.finderParkett,
  },
  {
    name: "Designbeläge und PVC",
    tag: "STRAPAZIERFÄHIG UND PFLEGELEICHT",
    desc: "Robust, vielseitig und für jedes Budget etwas dabei – ideal für den einfachen Wohnbereich oder die stark genutzte Gewerbeimmobilie.",
    img: IMG.finderDesign,
  },
  {
    name: "Linoleum und Kork",
    tag: "NACHHALTIG UND NATÜRLICH",
    desc: "Nachwachsende Naturmaterialien – fußwarm, leise und strapazierfähig.",
    img: IMG.finderKork,
  },
  {
    name: "Teppich und Teppichfliesen",
    tag: "LEISE UND ROBUST, FUSSWARM UND BEHAGLICH",
    desc: "Spürbar bessere Raumakustik, angenehm fußwarm und vielseitig einsetzbar – für konzentriertes Arbeiten im Büro und besonderen Wohnkomfort zu Hause.",
    img: IMG.finderTeppich,
  },
  {
    name: "Laminat",
    tag: "VIELSEITIG UND UNKOMPLIZIERT",
    desc: "Pflegeleicht, strapazierfähig und in zahlreichen Dekoren erhältlich – eine attraktive und preisbewusste Lösung für viele Wohnbereiche.",
    img: IMG.finderLaminat,
  },
  {
    name: "Raumakustik",
    tag: "WENIGER LÄRM. MEHR WOHLBEFINDEN",
    desc: "Akustiklösungen für spürbar angenehmere Räume – weniger Nachhall, bessere Sprachverständlichkeit und mehr Ruhe in Büro, Gewerbe und Zuhause.",
    img: IMG.finderAkustik,
  },
];

export const REFERENCES = [
  {
    title: "Altbau-Wohnung, Fulda",
    material: "Eiche-Parkett im Fischgrät",
    before: IMG.refBright,
    after: IMG.heroSecondary,
    story: "Ein abgewohnter Dielenboden aus den 60ern wurde komplett aufgearbeitet und durch ein neues Fischgrät-Parkett ergänzt – Charakter erhalten, Optik erneuert.",
  },
  {
    title: "Wohnhaus, Kalbach",
    material: "Designbelag Eiche natur",
    before: IMG.measuring,
    after: IMG.hero,
    story: "Heller, pflegeleichter Designbelag für eine junge Familie – warm im Auftritt, robust im Alltag mit Kindern und Hund.",
  },
  {
    title: "Büro & Homeoffice",
    material: "Akustik-Boden & Raumakustik",
    before: IMG.showroom,
    after: IMG.livingBright,
    story: "Ein Arbeitsraum, der nicht nur gut aussieht, sondern gut klingt: kombinierte Boden- und Akustiklösung für konzentriertes Arbeiten.",
  },
];

export const TEAM = [
  {
    name: "Konstantin Blum",
    role: "Geschäftsführer · TÜV-Raumakustik-Berater",
    img: IMG.team2,
  },
  {
    name: "Meisterteam Verlegung",
    role: "Handwerk mit Auszeichnung",
    img: IMG.team3,
  },
  {
    name: "Ausbildung bei Blum",
    role: "Mehrfach prämierter Ausbildungsbetrieb",
    img: IMG.team1,
  },
];

export const TEAM_STATS = [
  { value: "25+", label: "Mitarbeitende im Team" },
  { value: "3", label: "Generationen Familienbetrieb" },
  { value: "100%", label: "Ausbildung im eigenen Haus" },
];

export const INSTAGRAM = {
  handle: "@fussbodenblum",
  url: "https://www.instagram.com/fussbodenblum/",
  posts: [
    { img: IMG.parkett, caption: "Frisch verlegtes Eiche-Fischgrät – ein Klassiker, der nie aus der Mode kommt. 🪵", likes: 142, comments: 11 },
    { img: IMG.craftsman, caption: "Präzision beginnt beim Aufmaß. Handwerk, das man sieht. 📐", likes: 98, comments: 6 },
    { img: IMG.livingWarm, caption: "Warm, robust, alltagstauglich – Designbelag für eine junge Familie.", likes: 187, comments: 14 },
    { img: IMG.heroSecondary, caption: "Vorher/Nachher: aufgearbeitetes Parkett strahlt wie neu. ✨", likes: 231, comments: 22 },
    { img: IMG.cork, caption: "Nachhaltig & fußwarm: Naturmaterialien liegen uns am Herzen. 🌿", likes: 76, comments: 4 },
    { img: IMG.livingBright, caption: "Helle Räume, klare Linien – Boden als Bühne fürs Wohnen.", likes: 154, comments: 9 },
    { img: IMG.staff, caption: "Unser Team – mit Leidenschaft bei jedem Projekt dabei. ❤️", likes: 312, comments: 28 },
    { img: IMG.measuring, caption: "Detailarbeit zahlt sich aus: saubere Übergänge, perfekte Kanten.", likes: 119, comments: 7 },
  ],
};

export const PARKETT_STARS = [
  { year: "2016", area: "Vorbildliche Fortbildungsangebote im Handwerk" },
  { year: "2021", area: "Vorbildlicher Generationenwechsel im Handwerk" },
  { year: "2024", area: "Vorbildlicher Ausbildungsbetrieb im Handwerk" },
];

export const AWARDS = [
  { title: "Meisterbetrieb", sub: "Geprüfte handwerkliche Qualität" },
  { title: "TÜV Raumakustik", sub: "Zertifizierte Akustik-Kompetenz" },
  { title: "NCheck-360", sub: "Zertifizierte Nachhaltigkeit" },
];

export const TRUST = [
  "55+ Jahre Erfahrung",
  "Meisterbetrieb",
  "TÜV-zertifizierte Raumakustik",
  "Mehrfach prämierte Ausbildung",
  "Drei Generationen Handwerk",
  "Nachhaltigkeit NCheck-360",
];

// ---- Services template page (Leistungen) ----
export const PROCESS = [
  { n: "01", title: "Erstgespräch", text: "Wir lernen Ihr Projekt, Ihre Räume und Ihre Wünsche kennen – telefonisch oder in unserer Ausstellung." },
  { n: "02", title: "Aufmaß & Beratung", text: "Vor Ort prüfen wir Untergrund und Gegebenheiten und empfehlen das passende Material." },
  { n: "03", title: "Angebot", text: "Transparent, fair und ohne versteckte Posten – Sie wissen genau, was Sie erwartet." },
  { n: "04", title: "Verlegung", text: "Unser Meisterteam verlegt sauber, termintreu und mit Liebe zum Detail." },
  { n: "05", title: "Übergabe & Pflege", text: "Wir übergeben Ihren fertigen Boden und zeigen Ihnen die richtige Pflege." },
];

export const LEISTUNGEN_DETAIL = [
  {
    title: "Beratung & Planung",
    lead: "Bevor der erste Span fällt, steht das Gespräch.",
    text: "Wir nehmen uns Zeit, Ihre Räume, Ihren Alltag und Ihre Ansprüche zu verstehen und empfehlen ehrlich, was wirklich passt. Keine Standardlösung, sondern die richtige für Sie.",
    img: IMG.leistungPlanung,
    points: ["Persönliche Fachberatung", "Aufmaß vor Ort", "Materialauswahl in unserer Ausstellung", "Individuelle Planung"],
  },
  {
    title: "Verlegung & Handwerk",
    lead: "Die Verlegung ist Vertrauenssache.",
    text: "Unser Team arbeitet präzise, sauber und mit dem Anspruch, dass Sie lange Freude an Ihrem Boden haben – vom fachgerechten Untergrundaufbau bis zur letzten Sockelleiste.",
    img: IMG.leistungVerlegung,
    points: ["Untergrundvorbereitung", "Fachgerechte Verlegung", "Treppen & Sonderlösungen", "Saubere Detailausführung"],
  },
  {
    title: "Aufarbeitung, Reinigung & Pflege",
    lead: "Erhalten statt ersetzen.",
    text: "Nicht jeder Boden, der in die Jahre gekommen ist, muss ausgetauscht werden. Wir arbeiten Parkett und Holzböden fachgerecht auf und bringen auch elastische Bodenbeläge wie Linoleum, PVC und Designbeläge durch professionelle Grundreinigung und neue Beschichtungen wieder auf Vordermann. Das verlängert die Lebensdauer, erhält Werte und schont Ressourcen.",
    points: ["Schleifen & Versiegeln", "Ölen & Pflegen", "Reparaturen & Teilausbesserungen", "Grundreinigung elastischer Bodenbeläge", "Neuversiegelung & Beschichtung", "Pflegeberatung"],
    img: IMG.leistungReinigung,
  },
  {
    title: "Material & Unterstützung für Selbstverleger",
    lead: "Selber machen. Mit Unterstützung vom Profi.",
    text: "Nicht jeder Boden muss komplett von uns verlegt werden. Wer selbst mit anpacken möchte, bekommt bei uns das passende Material, die richtigen Verlege- und Hilfsstoffe und vor allem fachkundige Unterstützung. Auf Wunsch starten wir die Verlegung gemeinsam mit Ihnen und begleiten Sie genau so lange, wie Sie uns brauchen.",
    img: IMG.leistungMaterial,
    points: ["Materialverkauf für Selbstverleger", "Passende Verlege- und Hilfsstoffe", "Rückgabe nicht benötigter Hilfsstoffe", "Fachliche Einweisung", "Gemeinsamer Verlegestart", "Unterstützung nach Bedarf"],
  },
  {
    title: "Raumakustik",
    lead: "Gute Räume hören sich gut an.",
    text: "Mit durchdachten Akustiklösungen reduzieren wir störenden Nachhall und schaffen Räume, in denen man sich besser versteht und wohler fühlt – im Büro, in öffentlichen Bereichen und zu Hause.",
    img: IMG.leistungAkustik,
    points: ["Akustikberatung", "Akustikelemente für Wand & Decke", "Individuelle Lösungen", "Verbindung von Boden und Raumakustik"],
  },
];

export const FAQ = [
  { q: "Welcher Bodenbelag ist der richtige für mich?", a: "Das hängt ganz von Ihren Räumen, der Nutzung und Ihren persönlichen Vorstellungen ab. Parkett, Designbelag, Linoleum, Teppich oder Laminat haben jeweils ihre eigenen Stärken. Wir beraten Sie persönlich und ehrlich – gerne in unserer Ausstellung oder direkt bei Ihnen vor Ort." },
  { q: "Was kostet ein neuer Boden inklusive Verlegung?", a: "Das lässt sich pauschal nur schwer beantworten. Neben dem gewünschten Bodenbelag spielen die Raumgröße, der vorhandene Untergrund und die notwendigen Vorarbeiten eine wichtige Rolle. Nach Beratung und Aufmaß erhalten Sie von uns ein transparentes und nachvollziehbares Angebot." },
  { q: "Muss der alte Boden immer entfernt werden?", a: "Nein. Je nach vorhandenem Boden und Untergrund gibt es unterschiedliche Möglichkeiten. Bestehende Beläge können teilweise erhalten, überarbeitet oder als Untergrund genutzt werden. Gerade im Sinne der Nachhaltigkeit prüfen wir gerne, was erhalten werden kann und welche Lösung technisch sinnvoll ist." },
  { q: "Kann mein alter Parkettboden noch einmal aufgearbeitet werden?", a: "In vielen Fällen ja. Echtes Parkett kann je nach Aufbau und Zustand geschliffen, repariert und anschließend neu geölt oder versiegelt werden. Selbst ältere Bodenbeläge lassen sich so häufig wieder in einen hervorragenden Zustand versetzen. Wir schauen uns Ihren Boden gerne an und beurteilen, ob sich eine Aufarbeitung lohnt." },
  { q: "Können auch PVC-, Linoleum- oder Designböden aufgearbeitet werden?", a: "Ja. Auch elastische Bodenbeläge müssen bei Verschleiß oder starken Gebrauchsspuren nicht zwangsläufig ausgetauscht werden. Je nach Belag und Zustand können professionelle Grundreinigung, Pflege oder eine neue Beschichtung die Optik verbessern und die Nutzungsdauer deutlich verlängern." },
  { q: "Kann ich meinen Boden auch selbst verlegen und das Material bei Ihnen kaufen?", a: "Natürlich. Sie können Bodenbeläge sowie die benötigten Verlege- und Hilfsstoffe direkt bei uns beziehen. Wir beraten Sie zur richtigen Verarbeitung und unterstützen Sie auf Wunsch auch bei den ersten Arbeitsschritten. So können Sie genau so viel selbst übernehmen, wie Sie möchten – und bei Bedarf auf unsere fachliche Unterstützung zurückgreifen." },
  { q: "Eignet sich eine Fußbodenheizung für Parkett und andere Bodenbeläge?", a: "Grundsätzlich sind viele moderne Bodenbeläge für Fußbodenheizungen geeignet – auch Parkett. Entscheidend sind unter anderem die richtige Materialauswahl, der Aufbau und die fachgerechte Verlegung. Wir beraten Sie gerne, welche Lösung für Ihre Fußbodenheizung geeignet ist." },
  { q: "Wie lange dauert die Verlegung eines neuen Bodens?", a: "Das hängt von Fläche, Bodenbelag und Untergrund ab. Häufig nehmen die notwendigen Vorarbeiten mehr Zeit in Anspruch als die eigentliche Verlegung. Nach dem Aufmaß können wir den Ablauf realistisch einschätzen und mit Ihnen abstimmen." },
  { q: "Was muss ich vor der Verlegung vorbereiten?", a: "Das besprechen wir individuell mit Ihnen. Je nach Auftrag können beispielsweise Möbel oder vorhandene Bodenbeläge vorab entfernt werden – vieles davon können wir auf Wunsch aber auch übernehmen. Vor Beginn der Arbeiten stimmen wir gemeinsam ab, wer welche Leistungen übernimmt." },
  { q: "Bieten Sie auch Lösungen zur Verbesserung der Raumakustik an?", a: "Ja. Neben der Auswahl geeigneter Bodenbeläge bieten wir Lösungen zur Verbesserung der Raumakustik an. Mit passenden Akustikelementen lassen sich Nachhall und störende Geräusche reduzieren und die Sprachverständlichkeit verbessern – beispielsweise in Büros, Besprechungsräumen, öffentlichen Gebäuden oder im privaten Wohnbereich." },
];
